import ImageGallery from "components/image_gallery/image_gallery"
import OverviewImage from "components/overview_image"
import React from "react"
import {createRoot} from "react-dom/client"
import ajax from "ajax"

function init_overview_images(container) {
  return get_overview_image_data(container).then((images) => {
    if (images.length > 1) {
      render_image_gallery(container, images)
    } else {
      render_single_image(container, images)
    }
    container.classList.remove("spinner")
    container.style.aspectRatio = null
  })
}

function render_image_gallery(container, images) {
  createRoot(container).render(<ImageGallery images={images} />)
}

function render_single_image(container, images) {
  createRoot(container).render(
    React.createElement(OverviewImage, images[0])
  )
}

function get_overview_image_data(container) {
  const captions = JSON.parse(container.dataset.captions || "{}")
  const ids = container.dataset.overviewImageIds?.split(",")
  const {terminologyLanguage, ignoreUserTerminology} = container.dataset
  const term_language = terminologyLanguage ||
                      ignoreUserTerminology ||
                      window.gon.current_term_language
  return ajax.get(
    "/api/overview_images",
    {ids, term_language, locale: window.gon.locale}
  ).then((images) => {
    for (const image of images) {
      image.slug = `overview-image-${image.id}`
      image.caption = captions[image.id]
      image.title = image.caption?.title
      image.fullscreen_info = create_fullscreen_info(image.caption)
    }
    return images
  })
}

function create_fullscreen_info(caption) {
  if (!caption) return

  return (
    <div className="fullscreen-info">
      <div className="title">
        {caption.title}
      </div>
      <div
        className="description"
        dangerouslySetInnerHTML={{
          __html: caption.description
        }}
      >
      </div>
    </div>
  )
}

export default init_overview_images
